module.exports = __webpack_public_path__ + "img/stu.77d6f735.png";